(function () {
  'use strict';

  function sectionInner(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector('.shopify-section');
    return el ? el.innerHTML : html;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-sd-atc]')) return;
    if (!window.fetch) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var idInput = form.querySelector('input[name="id"]');
    if (!btn || !idInput) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(idInput.value), quantity: 1 }],
        sections: 'cart-icon-bubble'
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (data) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data.sections && data.sections['cart-icon-bubble']) {
          bubble.innerHTML = sectionInner(data.sections['cart-icon-bubble']);
        }
        btn.textContent = 'Added. Dangerous.';
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.textContent = label;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 2200);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        form.submit();
      });
  });
})();
